import React, { useEffect, useState } from 'react';
import { Tooltip } from '@material-ui/core';
import { NAME_TOOLTIP_DELAY_MS } from '../constants';
import { CardNames } from './blocks';

/**
 * Hover tooltip with a card's full name, around the card's title and description lines (which cut long text short).
 * It opens after a short delay, never on touch (a long press there starts a drag), and stays shut while any card is
 * being dragged, so it doesn't follow a lifted card or pop up over the cards a drag passes.
 *
 * @param {{ title: string, suppressed?: boolean, children: React.ReactNode }} props
 *   `suppressed` is true while a drag is in progress on the board.
 */
export const CardNameTooltip = ({ title, suppressed = false, children }) => {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (suppressed) setOpen(false);
    }, [suppressed]);

    return (
        <Tooltip
            title={title}
            open={open && !suppressed}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            enterDelay={NAME_TOOLTIP_DELAY_MS}
            enterNextDelay={NAME_TOOLTIP_DELAY_MS}
            disableHoverListener={suppressed}
            disableFocusListener
            disableTouchListener
            placement="top-start"
        >
            <CardNames>{children}</CardNames>
        </Tooltip>
    );
};

export default CardNameTooltip;
